<template>
  <el-upload
    :action="action"
    :headers="uploadHeader"
    :on-success="onSuccess"
    :on-error="onError"
    :on-exceed="onExceed"
    :on-remove="onRemove"
    :multiple="true"
    :limit="limit"
    :before-upload="beforeUpload"
    :file-list="fileList"
  >
    <el-button size="mini" type="primary" plain>选择附件</el-button>
  </el-upload>
</template>

<script>
import { urlPerfix } from '@/config/env'
import store from '@/store/index'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    limit: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      action: urlPerfix + '/files/upload',
      uploadHeader: { Token: store.state.userInfo.token },
      fileList: [],
    }
  },
  created() {
    this.fileList = this.value || []
  },
  methods: {
    onSuccess(response, file, fileList) {
      this.onFileChange(fileList)
    },

    beforeUpload(file) {
      const isLimitSize = file.size / 1024 / 1024 <= this.uploadLimitSize.file
      if (!isLimitSize) {
        this.$message.error(
          `文件：${file.name} 上传失败，文件大小不能超过${this.uploadLimitSize.file}MB!`
        )
      }
      return isLimitSize
    },

    onFileChange(fileList) {
        const attachments = fileList.map((file) => {
          return {
            name: file.name,
            url: file.url || file.response.data,
            size: file.size,
          }
        })
        this.$emit('input', attachments || [])
    },

    onError(err, file, fileList) {
      console.log(err)
    },

    onExceed(files, fileList) {
      this.$message.error(`最多只能上传${this.limit}个文件`)
    },

    onRemove(file, fileList) {
      this.onFileChange(fileList)
    },
  },
}
</script>